import dynamic from "next/dynamic";

export const DynamicHero031 = dynamic(() => import("./Hero031"), {
  suspense: true,
});
